"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSettingsColumnDetails = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Slider = _interopRequireDefault(require("../slider/Slider"));
var TableSettingsColumnDetails = function TableSettingsColumnDetails(props) {
  var _props$width = props.width,
    width = _props$width === void 0 ? 0 : _props$width,
    _props$defaultWidth = props.defaultWidth,
    defaultWidth = _props$defaultWidth === void 0 ? 0 : _props$defaultWidth,
    maxWidth = props.maxWidth,
    maxColumnWidth = props.maxColumnWidth,
    column = props.column,
    onColumnWidthChange = props.onColumnWidthChange,
    onResetColumnWidth = props.onResetColumnWidth;
  var handleWidthInputChange = function handleWidthInputChange(event) {
    var parsedValue = event.target.value ? parseInt(event.target.value, 10) : 0;
    var max = maxWidth || maxColumnWidth;
    var value = Math.min(parsedValue, max);
    onColumnWidthChange(column, value);
  };
  var handleColumnWidthChange = function handleColumnWidthChange(value) {
    return onColumnWidthChange(column, value);
  };
  var handleResetColumnWidth = function handleResetColumnWidth() {
    return onResetColumnWidth(column);
  };
  var resetWidthButtonClassNames = (0, _classnames["default"])('btn', 'btn-muted', 'btn-icon-only', 'btn-sm', 'margin-left-10', width === defaultWidth && 'disabled');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-settings-item-body"
  }, /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    className: "margin-bottom-0",
    value: width,
    minValue: 0,
    maxValue: maxWidth || maxColumnWidth,
    step: 1,
    onChange: handleColumnWidthChange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: resetWidthButtonClassNames,
    role: "button",
    onClick: handleResetColumnWidth
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "rioglyph rioglyph-revert"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "column-width-input"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "form-control text-right padding-right-5 no-controls",
    type: "number",
    value: width || '',
    min: 0,
    max: maxWidth || maxColumnWidth,
    onChange: handleWidthInputChange
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "input-group-addon"
  }, "px"))));
};
exports.TableSettingsColumnDetails = TableSettingsColumnDetails;
TableSettingsColumnDetails.defaultProps = {
  onColumnWidthChange: function onColumnWidthChange() {
    return undefined;
  },
  onResetColumnWidth: function onResetColumnWidth() {
    return undefined;
  }
};
TableSettingsColumnDetails.propTypes = {
  column: _propTypes["default"].string.isRequired,
  width: _propTypes["default"].number,
  defaultWidth: _propTypes["default"].number,
  maxWidth: _propTypes["default"].number,
  maxColumnWidth: _propTypes["default"].number.isRequired,
  onColumnWidthChange: _propTypes["default"].func,
  onResetColumnWidth: _propTypes["default"].func
};